var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-scroll-area',{staticStyle:{"height":"calc(100vh - 420px) !important"}},[(_vm.gridData.length > 0)?_c('div',{staticClass:"q-px-md"},_vm._l((_vm.gridData),function(event,index){return (event.lanes.length > 0)?_c('q-card',{key:("event_" + index),staticClass:"q-pa-md q-my-md",attrs:{"bordered":"","flat":""}},[_c('b',[_vm._v(_vm._s(event.event_no)+" - "+_vm._s(event.event_name))]),_vm._v(" "),_c('br'),_c('span',[_vm._v(_vm._s(event.round_name.includes("Round") ? event.round_name : event.round_name.split(" 1")[0])+" - "+_vm._s(event.race_index + 1))]),_c('datatable',{attrs:{"filter":_vm.search,"flat":true,"data":event.lanes,"columns":[
          {
            name: 'placing',
            label: 'Placing',
            field: 'placing',
            align: 'left',
            sortable: true,
          },
          {
            name: 'team_name',
            label: 'Participant',
            field: 'team_name',
            align: 'left',
            style:
              'min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;',
            sortable: true,
          },
          {
            name: 'association_abbr',
            label: 'Club',
            field: 'association_abbr',
            align: 'left',
            style:
              'min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;',
            sortable: true,
          },
          {
            name: 'master_time',
            label: 'Time',
            field: 'master_time',
            align: 'left',
            style:
              'min-width: 100px;max-width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;',
            sortable: true,
          },
          {
            name: 'points',
            label: 'Points',
            field: 'points',
            align: 'left',
            style:
              'min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;',
            sortable: true,
          } ]},on:{"rowDoubleClick":_vm.handleDoubleClick},scopedSlots:_vm._u([{key:"body-cell-association_abbr",fn:function(data){return [_c('q-td',{attrs:{"props":data.props}},[(data.props.row.capUrl)?_c('q-img',{staticClass:"q-ml-sm",attrs:{"src":data.props.row.capUrl,"width":"40px","contain":""}}):_vm._e(),_vm._v(" "+_vm._s(data.props.row.association_abbr)+" ")],1)]}}],null,true)})],1):_vm._e()}),1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }